import React from 'react'
import { Link } from 'react-router-dom'
import Fade from 'react-reveal/Fade';

const CtaSection = (props) => {
    return (
        <section 
            className="wpo-cta-section section-padding"
            style={{
                paddingTop: "40px",  
                paddingBottom: "40px" 
            }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="wpo-cta-wrap">
                            <div className="wpo-cta-item">
                                <div className="wpo-cta-text">
                                    <span>
                                        WE ARE HERE
                                    </span>

                                    <h2>
                                        Your trusted partner in global trade and Ethiopian exports
                                    </h2>
                                </div>
                                <div className="wpo-cta-btn">
                                    <Link 
                                        to="/contact"
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            padding: "10px 30px",
                                            borderRadius: "10px",
                                            color: "#fff",
                                            textTransform: "uppercase",
                                            fontWeight: "600",
                                            background: "linear-gradient(90deg, #001a4d, #004c99)",
                                            transition: "all 0.3s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = "scale(1.08)";
                                            e.currentTarget.style.boxShadow = "0 0 15px rgba(0, 76, 153, 0.7)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "scale(1)";
                                            e.currentTarget.style.boxShadow = "0 0 0 rgba(0, 76, 153, 0)";
                                        }}
                                    >
                                        Contact us
                                    </Link>
                                </div>
                                <Fade left>
                                    <div className="cta-shape">
                                        <svg
                                            width="325.000000pt"
                                            height="267.000000pt"
                                            viewBox="0 0 325.000000 267.000000"
                                            preserveAspectRatio="xMidYMid meet"
                                        >
                                            {/* Define the gradient */}
                                            <defs>
                                            <linearGradient id="ctaGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                                <stop offset="0%" style={{ stopColor: "darkblue", stopOpacity: 1 }} />
                                                <stop offset="100%" style={{ stopColor: "lightblue", stopOpacity: 1 }} />
                                            </linearGradient>
                                            </defs>

                                            {/* Apply the gradient to the shape path */}
                                            <g
                                            transform="translate(0.000000,267.000000) scale(0.100000,-0.100000)"
                                            stroke="none"
                                            >
                                            <path
                                                fill="url(#ctaGradient)"
                                                d="M0 1332 l0 -1332 920 0 919 0 39 53 c213 291 233 519 64 720 
                                                -101 119 -201 194 -617 462 -344 222 -452 297 -605 426 
                                                -320 268 -528 547 -676 906 -20 48 -38 90 -40 92 
                                                -2 2 -4 -595 -4 -1327z"
                                            />
                                            </g>
                                        </svg>                                      
                                    </div>
                                </Fade>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CtaSection;